<template>
    <v-card-text class="narrow-container">
        <v-form @keyup.native.enter="onLogin" class="d-flex flex-column">
            <v-text-field
                v-model="form.email"
                :error-messages="form.$errors.email"
                label="Enter your email adress"
                outlined
                type="email"
                @blur="form.validate('email')"
                @input="delete form.$errors.email"
            />

            <v-text-field
                v-model="form.password"
                :error-messages="form.$errors.password"
                autocomplete="current-password"
                label="Password"
                outlined
                required
                type="password"
                @blur="form.validate('password')"
                @input="delete form.$errors.password"
            />

            <div id="cf-turnstile" class="d-flex justify-center mb-5"></div>

            <v-btn :loading="form.$busy" block color="primary" depressed large rounded @click="onLogin" class="mb-12">
                Log In
            </v-btn>

            <router-link :to="{ name: 'ForgotPassword' }"
                         class="frontpage-link text-decoration-underline text-center mb-6"
            >
                Forgot your password?
            </router-link>

            <span class="frontpage-text text-center">
                Don't have an account?
                <router-link :to="{ name: 'register' }" class="frontpage-link text-decoration-underline">
                    Sign Up.
                </router-link>
            </span>
        </v-form>
    </v-card-text>
</template>

<script>
import * as rules from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import cloudflareConfig from '@/assets/js/config/CloudFlare'

export default {
    name: "Login",

    data() {
        return {
            cf_turnstile_widget_id: null,
            form: new Form(this, "form", {
                email: null,
                password: null,
                cf_turnstile_response: null
            }),
        };
    },

    validations: {
        form: {
            email: { required: rules.required, email: rules.email },
            password: { required: rules.required, minLength: rules.minLength(8) },
            cf_turnstile_response: { required: rules.required }
        },
    },

    async mounted() {
        await this.$loadScript(cloudflareConfig.turnstile.scriptURL);
        this.cf_turnstile_widget_id = window.turnstile.render('#cf-turnstile', {
            ...cloudflareConfig.turnstile,
            action: 'Login',
            callback: token => {
                this.form.cf_turnstile_response = token
            },
        })
    },

    methods: {
        ...mapActions("Auth", ["auth"]),

        async onLogin() {
            if (!this.form.validate()) {
                return;
            }

            let loginStatus = await this.$store.dispatch("Auth/login", {
                email: this.form.email,
                password: this.form.password,
                cf_turnstile_response: this.form.cf_turnstile_response
            });

            if (loginStatus == 'wrong-account') {
                this.$snackbar(`You tried to login with fylm.ai account. <a href="${window.FYLM_APP_URL}" style="color: white; text-decoration: underline">Please open fylm.ai</a> and login again.`, "warning");
                window.turnstile.reset(this.cf_turnstile_widget_id)
            }

            if (loginStatus == "incorrect") {
                this.$snackbar("Incorrect email or password.", "error");
                window.turnstile.reset(this.cf_turnstile_widget_id)
            }

			window.turnstile.remove(this.cf_turnstile_widget_id);

            if (loginStatus == '2FA') {
                this.$router.push({ name: 'LoginWith2FA', params: { email: this.form.email, password: this.form.password } });
            }
        },
    },
};
</script>